<div class="wrapper mb-5">
    <div class="row align-items-center m-0" style="padding: 10px;">
        <img class="p-2" src="./assets/icons/arrow.svg">
        <span class="label-title ml-2 mr-3">Novo Veiculo</span>
    </div>
    <div class="component-box container-fluid">
        <form class="col-12 m-0 p-0" [formGroup]="vehicleFormGroup" #vehicleForm="ngForm"
            (ngSubmit)="onSubmit(vehicleFormGroup.value)">
            <div class="container-fluid pt-4">
                <div class="row">
                    <!-- <div class="col-12 text-left component-title">
                        Novo Veiculo
                    </div> -->
                    <div class="col-12">
                        <div class="row m-0">
                            <!--   -->
                            <div class="col-lg-6 col-md-6 col-sm-12 py-2 border-right">
                                <div class="row m-0">
                                    <div class="col-lg-6 col-md-6 col-sm-12 py-2">

                                        <mat-form-field class="w-100">
                                            <mat-label class="label-required">Apelido:</mat-label>
                                            <input matInput formControlName="nickName" id="nickName" type="text" autocomplete="off">

                                            <mat-error
                                                *ngIf="(form.nickName.invalid && (form.nickName.dirty || form.nickName.touched)) && form.nickName.errors.required">
                                                Apelido é obrigatório!
                                            </mat-error>
                                            <mat-error
                                                *ngIf="(form.nickName.invalid && (form.nickName.dirty || form.nickName.touched)) && form.nickName.errors.maxlength">
                                                Apelido deve conter no máximo 100 caracteres.
                                            </mat-error>
                                            <mat-error
                                                *ngIf="(form.nickName.invalid && (form.nickName.dirty || form.nickName.touched)) && form.nickName.errors.minlength">
                                                Apelido deve conter no mínimo 3 caracteres.
                                            </mat-error>
                                        </mat-form-field>

                                        <mat-form-field class="w-100">
                                            <mat-label class="label-required">Placa:</mat-label>
                                            <input matInput formControlName="registrationPlate" id="registrationPlate" type="text" autocomplete="off" oninput="value = value.toUpperCase()" maxlength="8">

                                            <mat-error *ngIf="(form.registrationPlate.invalid && (form.registrationPlate.dirty || form.registrationPlate.touched)) && form.registrationPlate.errors.required">
                                                Placa é obrigatória!
                                            </mat-error>
                                            <mat-error *ngIf="(form.registrationPlate.invalid && (form.registrationPlate.dirty || form.registrationPlate.touched)) && (form.registrationPlate.errors.pattern || form.registrationPlate.errors.maxlength || form.registrationPlate.errors.minlength)">
                                                Placa inválida.
                                            </mat-error>
                                        </mat-form-field>

                                        <mat-form-field class="w-100">
                                            <mat-label class="label-required">Marca:</mat-label>
                                            <input matInput formControlName="manufacturer" id="manufacturer" type="text" autocomplete="off">

                                            <mat-error *ngIf="(form.manufacturer.invalid && (form.manufacturer.dirty || form.manufacturer.touched)) && form.manufacturer.errors.required">
                                                Marca é obrigatória!
                                            </mat-error>
                                        </mat-form-field>

                                        <mat-form-field class="w-100">
                                            <mat-label class="label-required">Modelo:</mat-label>
                                            <input matInput formControlName="model" id="model" type="text" autocomplete="off">

                                            <mat-error *ngIf="(form.model.invalid && (form.model.dirty || form.model.touched)) && form.model.errors.required">
                                                Modelo é obrigatório!
                                            </mat-error>
                                        </mat-form-field>
                                    </div>
                                    <div class="col-lg-6 col-md-6 col-sm-12 py-2">

                                        <mat-form-field class="w-100">
                                            <mat-label class="label-required">Ano Fabricação:</mat-label>
                                            <input matInput formControlName="manufactureYear" id="manufactureYear" type="number" autocomplete="off">

                                            <mat-error *ngIf="(form.manufactureYear.invalid && (form.manufactureYear.dirty || form.manufactureYear.touched)) && form.manufactureYear.errors.required">
                                                Ano Fabricação é obrigatória!
                                            </mat-error>
                                            <mat-error *ngIf="(form.manufactureYear.invalid && (form.manufactureYear.dirty || form.manufactureYear.touched)) && (form.manufactureYear.errors.maxlength || form.manufactureYear.errors.minlength)">
                                                Ano Fabricação inválido.
                                            </mat-error>
                                        </mat-form-field>

                                        <mat-form-field class="w-100">
                                            <mat-label class="label-required">Ano Modelo:</mat-label>
                                            <input matInput formControlName="modelYear" id="modelYear" type="number" autocomplete="off">

                                            <mat-error *ngIf="(form.modelYear.invalid && (form.modelYear.dirty || form.modelYear.touched)) && form.modelYear.errors.required">
                                                Ano Modelo é obrigatório!
                                            </mat-error>
                                            <mat-error *ngIf="(form.modelYear.invalid && (form.modelYear.dirty || form.modelYear.touched)) && (form.modelYear.errors.maxlength || form.modelYear.errors.minlength)">
                                                Ano Modelo inválido.
                                            </mat-error>
                                        </mat-form-field>

                                        <mat-form-field class="w-100">
                                            <mat-label class="label-required">Renavam:</mat-label>
                                            <input matInput formControlName="renavam" id="renavam" type="text" autocomplete="off" [maxLength]="11">

                                            <mat-error *ngIf="(form.renavam.invalid && (form.renavam.dirty || form.renavam.touched)) && form.renavam.errors.required">
                                                Renavam é obrigatório!
                                            </mat-error>
                                            <mat-error *ngIf="(form.renavam.invalid && (form.renavam.dirty || form.renavam.touched)) && form.renavam.errors.maxLength">
                                                Renavam deve conter no máximo 11 dígitos.
                                            </mat-error>
                                        </mat-form-field>

                                        <mat-form-field class="w-100">
                                            <mat-label>Odômetro inicial:</mat-label>
                                            <input matInput formControlName="startOdometer" id="StartOdometer" type="number" autocomplete="off">

                                            <!-- <mat-error *ngIf="(form.transactionsMaxValuePerDay.invalid && (form.transactionsMaxValuePerDay.dirty || form.transactionsMaxValuePerDay.touched)) && form.transactionsMaxValuePerDay.errors.required">
                                                Ano Fabricação é obrigatória!
                                            </mat-error> -->
                                        </mat-form-field>
                                    </div>
                                </div>
                            </div>

                            <div class="col-lg-6 col-md-6 col-sm-12 py-2">
                                <div class="row m-0">
                                    <div class="col-lg-6 col-md-6 col-sm-12 py-2">

                                        <mat-form-field class="w-100">
                                            <mat-label class="label-required">Consumo padrão:</mat-label>
                                            <input matInput formControlName="fuelConsumption" id="fuelConsumption" type="number" autocomplete="off">

                                            <!-- <mat-error *ngIf="(form.nome.invalid && (form.nome.dirty || form.nome.touched)) && form.nome.errors.required">
                                    Nome é obrigatório!
                                </mat-error>
                                <mat-error *ngIf="(form.nome.invalid && (form.nome.dirty || form.nome.touched)) && form.nome.errors.maxlength">
                                    Nome deve conter no máximo 100 caracteres.
                                </mat-error>
                                <mat-error *ngIf="(form.nome.invalid && (form.nome.dirty || form.nome.touched)) && form.nome.errors.minlength">
                                    Nome deve conter no mínimo 3 caracteres.
                                </mat-error> -->
                                        </mat-form-field>

                                        <mat-form-field class="w-100">
                                            <mat-label class="">Categoria:</mat-label>
                                            <mat-select formControlName="specieId" id="specieId">
                                                <mat-option disabled value="">Selecione...</mat-option>
                                                <mat-option
                                                    *ngFor="let itemSpecies of speciesList"
                                                    [value]="itemSpecies.id">
                                                    {{itemSpecies.description }}
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>

                                        <mat-form-field class="w-100">
                                            <mat-label>Valor máximo por transação:</mat-label>
                                            <input matInput formControlName="transactionMaxValue" id="transactionMaxValue" type="number" autocomplete="off">

                                            <!-- <mat-error *ngIf="(form.transactionMaxValue.invalid && (form.transactionMaxValue.dirty || form.transactionMaxValue.touched)) && form.transactionMaxValue.errors.required">
                                                Ano Fabricação é obrigatória!
                                            </mat-error> -->
                                        </mat-form-field>

                                    </div>
                                    <div class="col-lg-6 col-md-6 col-sm-12 py-2">

                                        <mat-form-field class="w-100">
                                            <mat-label class="">Tipo de Combustivel:</mat-label>
                                            <mat-select formControlName="fuelId" id="fuelId">
                                                <mat-option disabled value="">Selecione...</mat-option>
                                                <mat-option
                                                    *ngFor="let itemFuels of fuelsList"
                                                    [value]="itemFuels.id">
                                                    {{itemFuels.description }}
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>

                                        <mat-form-field class="w-100">
                                            <mat-label>Transações por dia:</mat-label>
                                            <input matInput formControlName="transactionsPerDay" id="transactionsPerDay" type="number" autocomplete="off">

                                            <!-- <mat-error *ngIf="(form.transactionsPerDay.invalid && (form.transactionsPerDay.dirty || form.transactionsPerDay.touched)) && form.transactionsPerDay.errors.required">
                                                Transações por dia é obrigatório!
                                            </mat-error> -->
                                        </mat-form-field>

                                        <mat-form-field class="w-100">
                                            <mat-label>Valor máximo de transações por dia:</mat-label>
                                            <input matInput formControlName="transactionsMaxValuePerDay" id="transactionsMaxValuePerDay" type="number" autocomplete="off">

                                            <!-- <mat-error *ngIf="(form.transactionsMaxValuePerDay.invalid && (form.transactionsMaxValuePerDay.dirty || form.transactionsMaxValuePerDay.touched)) && form.transactionsMaxValuePerDay.errors.required">
                                                Ano Fabricação é obrigatória!
                                            </mat-error> -->
                                        </mat-form-field>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row button-container mt-5 mb-3">
                    <div class="col-12 text-right">
                        <button class="custom-button-fullbtn-back custom-button-previous" (click)="goToBack()">
                            Voltar
                        </button>

                        <button type="submit" class="custom-button-full">
                            Cadastrar
                        </button>
                    </div>
                </div>

            </div>
        </form>
    </div>
</div>
